<style lang="scss" src="./component.scss"></style>

<template>
  <footer class="app-footer">
    <div class="app-footer__wrapper">
      <p class="app-footer__copyright-text">
        © {{ currentYear }}
        <span v-html="$t('footer.rights')" />
        <a
          class="app-footer__copyright-link"
          href="/support/privacy/"
          target="_blank"
        >
          {{ $t('footer.privacyPolicy') }}
        </a>
      </p>
    </div>
  </footer>
</template>

<script>
  export default {
    name: 'app-footer',
    computed: {
      currentYear() {
        return new Date().getFullYear();
      }
    }
  };
</script>
